export default "__VITE_ASSET__fb638ef7__"